/**
 * Mask an identifier for safe logging.
 * Returns '...' + last 4 chars for strings length >= 4,
 * '****' for short non-empty strings,
 * '' for null/undefined/empty.
 *
 * Preserves backend-log correlation during incident triage
 * while making the logged value non-reconstructable.
 */
export function maskId(id?: string | null): string {
  if (id === null || id === undefined || id === '') return '';
  if (id.length < 4) return '****';
  return '...' + id.slice(-4);
}

/**
 * Log an error with a typed meta object.
 * Forces callers to structure their metadata so drive-by
 * raw error calls can't slip raw PII.
 */
export function safeLogError(
  message: string,
  meta: Record<string, unknown> = {},
): void {
  console.error(message, meta);
}
